import { onMounted, ref } from "vue";
import { OFFER_TERMS } from "../../../../../config/business";

// Derive the visible delivery dates from the authoritative shipping option.
// Computed on the client in onMounted (not at setup) so the date-dependent
// string never differs between the SSR render and the first client render —
// the initial fallback below is identical on both, avoiding hydration
// mismatch; the precise dates fill in right after mount.
export function useProductDelivery() {
  const standardShipping = OFFER_TERMS.shippingOptions.standardUs;
  const deliveryRange = ref("");

  const computeDeliveryRange = () => {
    const fmt = (d: Date) =>
      d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    const addBusinessDays = (start: Date, days: number) => {
      const date = new Date(start);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        const dow = date.getDay();
        if (dow !== 0 && dow !== 6) added += 1;
      }
      return date;
    };
    const now = new Date();
    const min =
      standardShipping.handlingDays.min + standardShipping.transitDays.min;
    const max =
      standardShipping.handlingDays.max + standardShipping.transitDays.max;
    return `${fmt(addBusinessDays(now, min))} – ${fmt(
      addBusinessDays(now, max)
    )}`;
  };

  onMounted(() => {
    deliveryRange.value = computeDeliveryRange();
  });

  return {
    deliveryRange,
  };
}
